export const DEFAULT_JUMPER_DURATION_MINUTES = 10;
export const MIN_JUMPER_DURATION_MINUTES = 1;
export const MAX_JUMPER_DURATION_MINUTES = 30;
export const SECONDS_PER_MINUTE = 60;
export const MAX_JUMPER_SESSION_SPAN_MHZ = 1000; // 1 GHz

export const COUNTDOWN_TICK_MS = 1000;
export const LINKED_GROUPS_PAGE_SIZE = 100;
export const NESTED_GROUPS_INDENT_LEVEL_MAX = 1;

export const MIN_JUMPER_SUPPRESSION_TIME_S = 3;
export const MAX_JUMPER_SUPPRESSION_TIME_S = 100 * SECONDS_PER_MINUTE; // 100 minutes
export const MIN_JUMPER_SUPPRESSION_MAX_COUNT = 1;
export const MAX_JUMPER_SUPPRESSION_MAX_COUNT = 100;

export const DEFAULT_JUMPER_SUPPRESSION = {
  suppressionTime: 5,
  suppressionMaxCount: 10,
} as const;

export const JUMPER_BANDWIDTH_OPTIONS_MHZ = [2, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
export const DEFAULT_JUMPER_BANDWIDTH_MHZ = 10;
